import * as squint_core from 'squint-cljs/core.js';
import { h, render } from 'preact';
import { useState } from 'preact/hooks';
import * as dom from './cljdoc.client.dom.jsx';
import * as cljdoc_DOT_client_DOT_dom from './cljdoc.client.dom.jsx';
import * as flow from './cljdoc.client.flow.jsx';
import * as cljdoc_DOT_client_DOT_flow from './cljdoc.client.flow.jsx';
import * as lib from './cljdoc.client.library.jsx';
import * as cljdoc_DOT_client_DOT_library from './cljdoc.client.library.jsx';
import { ListSearch } from './cljdoc.client.list-search.jsx';
import * as cljdoc_DOT_client_DOT_list_search from './cljdoc.client.list-search.jsx';
import * as str from 'squint-cljs/src/squint/string.js';
import * as clojure_DOT_string from 'squint-cljs/src/squint/string.js';
var clean_search_str = function (s) {
return str.replace(s, /[{}\[\]\"]/, "");

};
var load_results = function (q, call_back) {
const url_1 = `${"/api/search?q="}${q??''}`;
return fetch(url_1).then((function (response) {
return response.json();

})).then((function (json) {
return json.results;

})).then((function (results) {
return call_back(results);

}));

};
var load_results_debounced = flow.debounced(300, load_results);
var RowView = function (p__11335) {
const map___1_3 = p__11335;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const result_5 = squint_core.get(map___1_4, "result");
const isSelected_6 = squint_core.get(map___1_4, "isSelected");
const uri_7 = lib.docs_path(result_5);
const rowClass_8 = ((squint_core.truth_(isSelected_6)) ? ("pa3 bb b--light-gray bg-light-blue") : ("pa3 bb b--light-gray"));
return <><a class="no-underline black" href={uri_7}><div class={rowClass_8}><h4 class="dib ma0">{lib.project(result_5)}<span class="ml2 gray normal">{squint_core.get(result_5, "version")}</span></h4><a class="link blue ml2" href={uri_7}>view docs</a><div class="gray f6">{squint_core.get(result_5, "blurb")}</div><div class="gray i f7">{squint_core.get(result_5, "origin")}</div></div></a></>;

};
var LibSearch = function (p__11336) {
const map___1_3 = p__11336;
const map___1_4 = ((squint_core.truth_(squint_core.sequential_QMARK_(map___1_3))) ? (((squint_core.truth_(squint_core.vector_QMARK_(map___1_3))) ? (map___1_3) : (squint_core.seq_to_map_for_destructuring(map___1_3)))) : (map___1_3));
const initialValue_5 = squint_core.get(map___1_4, "initialValue");
const vec___6_9 = useState([]);
const results_10 = squint_core.nth(vec___6_9, 0, null);
const set_results_BANG__11 = squint_core.nth(vec___6_9, 1, null);
return <><ListSearch initialValue={initialValue_5} place-holder-text="Jump to docs..." results={results_10} rowView={RowView} resultsFetcher={(function (q) {
const q_12 = clean_search_str(q);
return load_results_debounced(q_12, set_results_BANG__11);

})} onActivateItem={(function (item) {
return window.open(lib.docs_path(item), "_self");

})}></ListSearch></>;

};
var init = function () {
const search_node_1 = dom.query("[data-id='cljdoc-search']");
if (squint_core.truth_(((squint_core.truth_(search_node_1)) ? (search_node_1.dataset) : (search_node_1)))) {
return render(h(LibSearch, ({"initialValue": search_node_1.dataset.initialValue})), search_node_1);
};

};

export { LibSearch, init }
